export const DEFAULT_GEARBOX_INERTIA = 0;
